<template>
    <div>
        <Banner :banners="banners" show-overlay class="white"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper white">
            <h2 class="title text-center">步數計算機</h2>
            <p class="carbon-text-sm">
                選擇走讀綠川、柳川的路線，消耗碳排放量之餘，別忘了同時認識臺中市美麗的水岸環境~
            </p>
            <div class="lists">
                <div v-for="(item, index) in list" :key="index" class="introStyle">
                    <a :href="item.url" target="_blank">
                        <div class="top" :class="getTopBg(index)">
                            <div class="leftBox">
                                <div class="order" :class="{ 'greenOrder': index === 1 }">{{ item.order }}</div>
                                <div class="imgBox">
                                    <img :src="item.imgUrl" alt="location">
                                </div>
                            </div>
                            <div class="locationStyle">
                                <div v-for="(location, idx) in item.locations" :key="idx">
                                    <p>{{ location }}</p>
                                    <p class="arrow">
                                        {{ getArrow(idx) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="bottom" :class="getBottomBg(index)">
                            <p>{{ item.km }}</p>
                            <p>{{ item.kg }}</p>
                        </div>
                    </a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
            list: [
                {
                    order: 'A',
                    imgUrl: require('@/assets/calculator/stepCalculator_A.jpg'),
                    url: 'https://maps.app.goo.gl/VykrLfRCaNLVBuHh6',
                    locations: [
                        '長春公園',
                        '綠川水文化暨環境教育館',
                        '新盛綠川水岸廊道',
                    ],
                    km: '約1.5公里、2500步(依個人步伐而異)',
                    kg: '消耗0.356kg的二氧化碳',
                },
                {
                    order: 'B',
                    imgUrl: require('@/assets/calculator/stepCalculator_B.jpg'),
                    url: 'https://maps.app.goo.gl/3NQd7wpxg4fYZhio9',
                    locations: [
                        '林之助紀念廣場',
                        '柳川水岸景觀步道',
                        '林之助紀念廣場',
                    ],
                    km: '約0.85公里、1420步(依個人步伐而異)',
                    kg: '消耗0.200kg的二氧化碳',
                },
            ],
        };
    },
    methods: {
        getArrow(i) {
            if (i < 2) {
                return '↓';
            }
            return null;
        },
        getTopBg(index) {
            return index === 0 ? 'topBlue' : 'topGreen';
        },
        getBottomBg(index) {
            return index === 0 ? 'bottomBlue' : 'bottomGreen';
        },
    },
    components: {
        Banner,
        Breadcrumb,
    },
    mixins: [coreMixin],
};
</script>

<style lang="sass" scoped>
.lists
    display: grid
    gap: 16px
    .introStyle
        position: relative
        display: flex
        flex-direction: column
        a
            color: unset
    .topBlue
        background-color: rgba(238, 248, 255, 1)
    .topGreen
        background-color: #E8F3EC
    .top
        display: flex
        padding: 8px 8px 16px 8px
        gap: 4px
        border-top-right-radius: 12px
        border-top-left-radius: 12px
        .leftBox
            display: flex
            flex-grow: 0
            gap: 4px
            .imgBox
                width: 150px
                img
                    width: 100%
                    object-fit: cover
                    border-radius: 6px
            .order
                font-size: 48px
                color: #6882A5
                font-weight: 700
            .greenOrder
                color: #89AE55
        .locationStyle
            flex-grow: 1
            p
                margin-bottom: 0px
                font-size: 14px
                font-weight: 700
                text-align: center
    .bottomBlue
        background-color: rgba(216, 239, 255, 1)
    .bottomGreen
        background-color: #BFD88E
        p
            color: #fff !important
    .bottom
        display: inline-block
        width: 100%
        position: relative
        top: -10px
        left: 0
        padding: 16px 8px
        border-radius: 12px
        p
            font-size: 14px
            color: #555555
            text-align: center
            margin-bottom: 0px
</style>
